
import { SagaIterator } from 'redux-saga';
import { all, call, delay, put, takeLatest } from 'redux-saga/effects';
import actions from './actions';
import apis from './apis';
import { setHeader } from 'common';
import type { Staff } from 'types/models';

export const getCategories = function* (): SagaIterator {
  try {
    const { cate, ser } = yield all({ cate: call(apis.getCategories), ser: call(apis.getServices) });

    const categoriesRes = cate?.data?.payload;
    const servicesRes = ser?.data?.payload;
    if (categoriesRes && servicesRes) {
      const data = categoriesRes.map((o: any) => ({
        id: o.id?.toString(),
        name: o.categoryName,
        services: servicesRes.filter((s: any) => s.catId === o.id).map((s: any) => ({
          cateId: o.id?.toString(),
          id: s.id?.toString(),
          image: s.urlImage,
          name: s.serviceName,
          duration: s.duration,
          price: s.price,
        })),
      }));
      yield put(actions.data.category.success(data));
    }
  } catch (error) { }
};

const getStaffs = function* (): SagaIterator {
  try {
    const res = yield call(apis.getStaffs);
    const staffRes = res?.data?.payload;
    if (staffRes) {
      const data = staffRes.map((o: Staff) => ({
        avatar: o.urlImage,
        extraData: o,
        id: o.id?.toString(),
        name: o.firstName,
      }));
      yield put(actions.data.staff.success(data));
    }
  } catch (error) { }
};
const getStaffAvailable = function* ({ payload }: { payload: Record<string, unknown> }): SagaIterator {
  try {
    const res = yield call(apis.getStaffAvailable, payload);
    const staffRes = res?.data?.payload;
    if (staffRes) {
      const data = staffRes.map((o: Staff) => ({
        avatar: o.urlImage,
        extraData: o,
        id: o.id?.toString(),
        name: o.firstName,
      }));
      yield put(actions.data.staffAvailable.success(data));
    }
  } catch (error) { }
};

// no SagaIterator annotation: yields all() over plain iterators (not effects)
export const initShopData = function* () {
  yield all([getShopDetailInfo(), getCategories(), getStaffs()]);
};

const getShopDetailInfo = function* (): SagaIterator {
  yield delay(200);
  try {
    const res = yield call(apis.shopInfo);
    const resData = res.data.payload;
    if (resData) {
      yield put(actions.data.shopInfo.success(resData));
    }
  } catch (error) { }
  finally {
    yield put(actions.setShopLoading(false));
  }
};
const getAllBanner = function* (): SagaIterator {
  try {
    const res = yield call(apis.allBannerByShop);
    const resData = res.data.payload;
    if (resData) {
      yield put(actions.data.allBanner.success(resData));
    }
  } catch (error) { }
};

const getStaffShopsByPhone = function* ({ payload }: { payload: string | undefined }): SagaIterator {
  try {
    const res = yield call(apis.staffShopsByPhone, payload);;
    const resData = res.data.payload;
    if (resData) {
      yield put(actions.data.staffShopsByPhone.success(resData));
    }
  } catch (error) { }
}

// no SagaIterator annotation: yields all() over plain iterators (not effects)
const initWithApiKey = function* ({ payload }: { payload: string }) {
  const key = payload;
  setHeader(key);
  yield put(actions.setShopLoading(true));
  yield delay(200);
  yield all([getShopDetailInfo(), getCategories(), getStaffs()]);
};


export default function* shopServiceSagas(): SagaIterator {
  yield takeLatest(actions.init, initShopData);
  yield takeLatest(actions.initWithApiKey, initWithApiKey);
  yield takeLatest(actions.data.shopInfo.fetch, getShopDetailInfo);
  yield takeLatest(actions.data.allBanner.fetch, getAllBanner);
  yield takeLatest(actions.data.staffShopsByPhone.fetch, getStaffShopsByPhone);
  yield takeLatest(actions.data.staffAvailable.fetch, getStaffAvailable);
}
